import React from 'react';
import { ManageContractsProvider } from './contractManagementContext';
import { ManageContracts } from './ManageContracts';

export const ManageContractsWrapper: React.FunctionComponent = () => {
  return (
    <ManageContractsProvider>
      <ManageContracts />
    </ManageContractsProvider>
  );
};
